import React, { useState } from "react";

// module imports

// import "./ThreeWayMatching.css";
import ThreeWayMatching from "./ThreeWayMatching.jsx";
import TWMOverviewDashboard from "./TWMOverviewDashboard.jsx";
import axios from "axios";
import { API_ENDPOINT } from "../../../services/api/resources.js";
import { useSelector } from "react-redux";
import { Box, Button, Card, Grid, Stack, Typography } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import HeaderTitle from "../../../components/common/HeaderTitle/HeaderTitle.jsx";



export const TWMHome = () => {

    const loginData = useSelector((state) => state.loginData.value);
    const [auth_token] = useState(loginData?.auth_token);
    const [user_token] = useState(loginData?.user?.user_token);
    const [user_role] = useState(loginData?.user?.role);

    const [nextTwmCode, setNextTwmCode] = useState("");

    const [mode, setMode] = useState("main");


    const fetchNextCode = async () => {
        try {
            const { data } = await axios.post(
                API_ENDPOINT.peek_next_twm_code,
                { user_token },
                { headers: { Authorization: `Bearer ${auth_token}` } }
            );
            setNextTwmCode(data?.next_match_code || "");
        } catch {
            setNextTwmCode("");
        }
    };


    return (
        <Box sx={{ minWidth: 0, pt: 0.25, pb: 3, borderRadius: 3, background: "radial-gradient(ellipse at 95% 0%, #e5efff 0%, transparent 45%), #f7f9fd" }}>

            <Stack direction={{ xs: "column", sm: "row" }} justifyContent="space-between" alignItems={{ xs: "flex-start", sm: "center" }} spacing={2}
                sx={{ m: { xs: 1.25, sm: 2 }, mb: 3, p: { xs: 2.5, md: 3.5 }, borderRadius: 4, color: "#ffffff", background: "radial-gradient(ellipse at 92% 0%, #4277e570, transparent 55%), linear-gradient(115deg, #10264d, #173b75 65%, #2455a0)", border: "1px solid #3e6bb3", boxShadow: "0 14px 36px #1d4ed825", overflow: "hidden" }}>
                <Box>
                    <Typography sx={{ fontFamily: "GilroyBold", fontSize: "11px", letterSpacing: "0.16em", color: "#a5c7ff", mb: 1 }}>FINANCE WORKSPACE</Typography>
                    <Typography component="h1" sx={{ fontFamily: "GilroyBold", fontSize: { xs: "23px", md: "29px" }, lineHeight: 1.25, color: "#ffffff" }}>Accounts Payable Automation</Typography>
                    <Typography sx={{ mt: 1, fontFamily: "gilroyMedium", fontSize: "14px", lineHeight: 1.7, color: "#c9dbf6" }}>One workspace to reconcile documents, review exceptions, and understand your payables.</Typography>
                </Box>
                <Box sx={{ flexShrink: 0, px: 2.5, py: 1.5, border: "1px solid #ffffff30", borderRadius: 3, backgroundColor: "#ffffff0d", display: { xs: "none", md: "block" } }}>
                    <Typography sx={{ fontFamily: "GilroyBold", fontSize: "25px", color: "#ffffff", letterSpacing: "0.15em" }}>2 - 3 -  4</Typography>
                    <Typography sx={{ fontSize: "12px", color: "#bfd7ff", mt: 0.25 }}>Matching workflows</Typography>
                </Box>

                {/* {mode == 'main' && user_role == "Buyer" && (
                    <Button
                        variant="contained"
                        color="primary"
                        startIcon={<CloudUploadIcon />}
                        onClick={async () => {
                            await fetchNextCode();
                            setMode("upload");
                        }}
                        sx={{
                            ml: { xs: 0, sm: 2 },
                            width: { xs: "100%", sm: "auto" },
                            fontWeight: 600,
                            textTransform: "none",
                            borderRadius: 2,
                            fontSize: "14px",
                        }}
                    >
                        Run 3-Way Match
                    </Button>
                )} */}
            </Stack>


           



            {/* <TWMOverviewDashboard /> */}
            <ThreeWayMatching nextTwmCode={nextTwmCode} uploadmode={mode} onModeChange={setMode} />
        </Box>
    )
}
